<template>
  <AppModal heading="Add New Card" @close="closeModal(null)">
    <div slot="content">
      <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="md:flex">
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pr-5"
              rules="required"
            >
              <label class="font-medium">Account Holder Name</label>
              <input
                class="form-input"
                type="text"
                name="Account Holder Name"
                placeholder="Account Holder Name"
                v-model="formData.account_holder_name"
              >
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pl-5"
              rules="required"
            >
              <label class="font-medium">Account Type</label>
              <select
                class="form-input focus:text-opacity-100"
                v-model="formData.account_holder_type"
                name="Account Type"
                :class="{'text-dark text-opacity-50': !formData.account_holder_type}"
              >
                <option value="" disabled>Account Type</option>
                <option value="Individual">Individual</option>
                <option value="Company">Company</option>
              </select>
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="md:flex">
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pr-5"
              rules="required|min:9"
            >
              <label class="font-medium">Routing Number</label>
              <input
                class="form-input"
                type="text"
                name="Routing"
                placeholder="110000000"
                v-model="formData.routing_number"
              >
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pl-5"
              rules="required"
            >
              <label class="font-medium">Account Number</label>
              <input
                class="form-input"
                type="text"
                name="Account Number"
                placeholder="000123456789"
                v-model="formData.account_number"
              >
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <button :disabled="createAchAccount" class="new-app-btn bg-blue">Save Account</button>
        </form>
      </ValidationObserver>
    </div>
  </AppModal>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'NewAchModal',
  data() {
    return {
      formData: {
        country: "US",
        currency: "USD",
        routing_number: '',
        account_number: '',
        account_holder_name: '',
        account_holder_type: '',
        createAchAccount: false
      },
      stripe: null
    }
  },
  mounted() {
    this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_TOKEN)
  },
  methods: {
    ...mapActions ([
      'addBuyerAccount'
    ]),
    closeModal(added) {
      this.$emit('close', added)
    },
    async onSubmit() {
      this.createAchAccount = true;
      const response = await this.createTokenFromStripe()
      if (response.token) {
        this.saveBuyerAccount(response.token)
      } else if (response.error) {
        this.$notify({
          group: 'buyHive',
          type: 'error',
          text: response.error.message,
          duration: 7000
        })
      }
      this.createAchAccount = false;         
    },
    createTokenFromStripe() {
      return this.stripe.createToken("bank_account", this.formData)
    },
    async saveBuyerAccount(token) {
      const response = await this.addBuyerAccount(token.id)
      if (response.result) this.closeModal(true)
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message,
        duration: 7000
      })
    }
  }
}
</script>
